export const mapPrices = (price) => ({
  id: price.id,
  ticker: price.ticker,
  name: price.name,
  currentValue: price.current_value,
  closeValue: price.close_value,
  closeTimestamp: price.close_timestamp,
  dayChange: price.day_change,
  dayValue: price.day_value,
  weekChange: price.week_change,
  weekValue: price.week_value,
  monthChange: price.month_change,
  monthValue: price.month_value,
  closeMarketCap: price.close_market_cap,
  closeVolume: price.close_volume,
  image: price.image,
  lastUpdated: price.last_updated,
  highestVolume: price.highest_volume,
  sector: price.sector_name,
  class: price.class_name,
  isCustom: price.is_custom,
  relatedCoin: price.related_coin,
  discountPercent: price.discount_percent
})

export const mapInstrumentsPrices = (instrument) => ({
  id: instrument.id,
  currentValue: instrument.current_value,
  lastUpdated: instrument.last_update,
  baseCurrency: instrument.base_currency,
  rho: instrument.rho,
  theta: instrument.theta,
  vega: instrument.vega,
  gamma: instrument.gamma,
  delta: instrument.delta,
})
